<template>
  <div
    class="container"
    :class="{ logged: $auth.check(), [type]: true }"
    @mouseleave="openDialog = false"
  >
    <div
      class="icon-container"
      @click="openDialog = true"
      @mouseover="openDialog = true"
    >
      <div class="floating front">
        <img v-if="imageUrl" :src="imageUrl" @error="handleError" />
      </div>
      <div class="floating back">
        <i class="fas fa-user"></i>
      </div>
    </div>
    <div class="list" :class="{ open: openDialog }">
      <div class="">
        <template v-if="$auth.ready()" class="big">
          <template v-if="$auth.check()">
            <router-link class="item" :to="{ name: 'dashboard' }">
              {{ $t("header.dashboard") }}
            </router-link>
            <router-link
              class="item"
              :to="{
                name: 'model.username',
                params: { username: `@${user.username}` },
              }"
            >
              {{ $t("header.my_wall") }}
            </router-link>
            <a class="item" :href="WEBSTARPANEL_URL">{{ $t("header.my_panel") }}</a>
            <a class="item" v-if="chatUrl" :href="chatUrl">{{ $t("header.my_chat") }}</a>
            <a @click.prevent="logout" class="item" href="#">
              {{ $t("header.logout") }}
            </a>
          </template>
          <template v-else>
            <router-link class="item" :to="{ name: 'login' }">
              {{ $t("header.login_user") }}
            </router-link>
            <a v-if="webstarsPanelUrl" class="item" :href="webstarsPanelUrl">
              {{ $t("header.webstars_panel") }}
            </a>
          </template>
        </template>
      </div>
    </div>
  </div>
</template>

<script>
import FontAwesome from "../../../public/js/lib/FontAwesomeKit"; // <--- importing FontAwesome icons
import eventbus from "../../eventbus";
import resources from "../../resources";
import ThemeManager from "../../modules/ThemeManager/ThemeManager";

export default {
  props: {
    type: {
      type: String,
      default: "desktop",
    },
  },
  data() {
    return {
      openDialog: false,
      // webstarsPanelUrl: process.env.VUE_APP_WEBSTARS_PANEL_URL,
      webstarsPanelUrl: "/login?redirect=webstars-panel",
      imageUrl: null,
      WEBSTARPANEL_URL: resources.webstars.HomeUrl(),
    };
  },
  methods: {
    logout() {
      this.imageUrl = null;
      // Cache.deleteUserProfilePic();
      this.$auth.logout();
    },
    handleError() {
      this.imageUrl = null;
      // Cache.deleteUserProfilePic();
    },
  },
  mounted() {
    // const cachedImage = Cache.getUserProfilePic();
    this.imageUrl = ThemeManager.parseWebstarDefaultsImageUrl(this.user.profile_pic);

    eventbus.onUpdateProfile(({ profile_pic }) => {
      if (profile_pic) this.imageUrl = ThemeManager.parseWebstarDefaultsImageUrl(profile_pic);
    });
  },
  computed: {
    user() {
      let user = {};

      if (this.$auth.ready() && this.$auth.check()) {
        user = this.$auth.user();
      }

      return user;
    },
    chatUrl() {
      return this.$store.state.chat_url;
    },
  },
  watch: {
    "$store.state.general.site_type": function() {
      console.log("profile_pic changed");
      this.imageUrl = ThemeManager.parseWebstarDefaultsImageUrl(this.imageUrl);
    }
  }
};
</script>

<style scoped lang="scss">
@import "../../styles/variables";

$SIZE: 2.5em;
$MOBILE_SIZE: 30px;

.container {
  width: $SIZE;
  height: $SIZE;
  border-radius: 100%;
  // border: 1px solid var(--pallete_dark_text_color);
  border: 1px solid var(--pallete_main_color);
  background-color: var(--background_02);
  cursor: pointer;

  @media (max-width: 768px) {
    width: $MOBILE_SIZE;
    height: $MOBILE_SIZE;
  }

  &.desktop {
    position: relative;

    @media (max-width: 768px) {
      // display: none;
    }

    .list {
      right: 0;
    }
  }

  &.mobile {
    position: absolute;

    @media (min-width: 768px) {
      display: none;
    }

    .list {
      left: 0;
    }
  }

  .icon-container {
    position: relative;
    display: flex;
    width: 100%;
    height: 100%;

    .floating {
      position: absolute;
      width: 100%;
      height: 100%;
      border-radius: 100%;
      display: flex;
      justify-content: center;
      align-items: center;

      &.front {
        z-index: 10;
      }

      &.back {
        z-index: 5;

        @media (max-width: 768px) {
          font-size: 0.75em;
        }
      }
    }

    i {
      text-align: center;
      margin: auto;
      color: var(--pallete_main_color);
    }

    img {
      width: 100%;
      height: 100%;
      border-radius: 50%;
    }
  }

  .logged {
    border: 1px solid var(--pallete_main_color);

    i {
      color: var(--pallete_main_color);
    }
  }

  .list {
    display: none;
    position: absolute;
    top: 36px;
    width: 200px;
    height: auto;
    background-color: rgba(0, 0, 0, 0.75);
    color: #ffffff;
    z-index: 20;

    &.open {
      display: block;
    }

    .item {
      min-width: 120px;
      display: block;
      text-align: center;
      color: inherit;
      text-decoration: none;
      text-transform: uppercase;
      font-weight: bold;
      font-size: 16px;
      padding: 0.75em 0;
      flex-grow: 1;
      transition: background-color 0.2s ease-in-out;

      &.router-link-active {
        background-color: lighten(#000000, 50);
      }

      // &:hover{
      //     background-color: lighten(#000000, 30);
      // }

      &:hover {
        background-color: var(--pallete_clear_text_color);
        color: var(--pallete_dark_color);
      }
    }
  }
}
</style>
